/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountInformation } from './AccountInformation';
import {
    AccountInformationFromJSON,
    AccountInformationFromJSONTyped,
    AccountInformationToJSON,
    AccountInformationToJSONTyped,
} from './AccountInformation';

/**
 * 
 * @export
 * @interface ProductServiceOutput
 */
export interface ProductServiceOutput {
    /**
     * the unique id
     * @type {string}
     * @memberof ProductServiceOutput
     */
    id?: string;
    /**
     * the description of the product or servive
     * @type {string}
     * @memberof ProductServiceOutput
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductServiceOutput
     */
    portfolio?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceOutput
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductServiceOutput
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProductServiceOutput
     */
    lastAction?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ProductServiceOutput
     */
    isRequiredNewBr?: boolean;
    /**
     * 
     * @type {AccountInformation}
     * @memberof ProductServiceOutput
     */
    accountInformation?: AccountInformation;
    /**
     * the view to visualize
     * @type {ProductServiceOutputViewEnum}
     * @memberof ProductServiceOutput
     */
    view?: ProductServiceOutputViewEnum;
}


/**
 * @export
 */
export const ProductServiceOutputViewEnum = {
    Memberzone: 'MEMBERZONE',
    Product: 'PRODUCT',
    Case: 'CASE',
    VideoIdentification: 'VIDEO_IDENTIFICATION'
} as const;
export type ProductServiceOutputViewEnum = typeof ProductServiceOutputViewEnum[keyof typeof ProductServiceOutputViewEnum];


/**
 * Check if a given object implements the ProductServiceOutput interface.
 */
export function instanceOfProductServiceOutput(value: object): value is ProductServiceOutput {
    return true;
}

export function ProductServiceOutputFromJSON(json: any): ProductServiceOutput {
    return ProductServiceOutputFromJSONTyped(json, false);
}

export function ProductServiceOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductServiceOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'description': json['description'] == null ? undefined : json['description'],
        'portfolio': json['portfolio'] == null ? undefined : json['portfolio'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'lastAction': json['lastAction'] == null ? undefined : (new Date(json['lastAction'])),
        'isRequiredNewBr': json['isRequiredNewBr'] == null ? undefined : json['isRequiredNewBr'],
        'accountInformation': json['accountInformation'] == null ? undefined : AccountInformationFromJSON(json['accountInformation']),
        'view': json['view'] == null ? undefined : json['view'],
    };
}

export function ProductServiceOutputToJSON(json: any): ProductServiceOutput {
    return ProductServiceOutputToJSONTyped(json, false);
}

export function ProductServiceOutputToJSONTyped(value?: ProductServiceOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'description': value['description'],
        'portfolio': value['portfolio'],
        'type': value['type'],
        'status': value['status'],
        'lastAction': value['lastAction'] == null ? value['lastAction'] : value['lastAction'].toISOString(),
        'isRequiredNewBr': value['isRequiredNewBr'],
        'accountInformation': AccountInformationToJSON(value['accountInformation']),
        'view': value['view'],
    };
}

